import React from 'react';
import {
  Stack,
  Text,
  Icon,
  withTranslation,
} from '@piwikpro/ui-components';
import { TFunction } from 'react-i18next';

interface Props {
  t: TFunction
}

export const CookieInformationCreateAccountSuccess: React.FC<Props> = ({ t }) => (
  <Stack vertical horizontalAlignment="middle">
    <Stack.Item>
      <Icon size="large" color="green" name="checkmark-circle-outline" />
    </Stack.Item>
    <Stack.Item>
      <Text as="h3" size={16} weight={700} wrapType="noWrapAndCutText" dataId="Header.small">
        {t('cookieInformation.success.title')}
      </Text>
    </Stack.Item>
    <Stack.Item previousSpacing="narrow">
      <Text as="p" align="center">
        {t('cookieInformation.success.successDescription')}
      </Text>
    </Stack.Item>
  </Stack>
);

export default withTranslation(['administration'])(CookieInformationCreateAccountSuccess);
